export default "__VITE_ASSET__xt1060hw__"